import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../services/apiClient';
import { DomainLookupResponse } from '../types/DomainLookupTypes';

/**
 * Fast exact-match threat lookup (ENG-925): no date window, no company scope,
 * one request for up to 100 domains. Replaces the year-by-year sweep over
 * `GET /v2/assets/threats` that Domain 360 used to run.
 */
export const lookupDomainsApi = async (
  domains: string[],
  signal?: AbortSignal,
): Promise<DomainLookupResponse> => {
  const query = domains
    .map(domain => `domain=${encodeURIComponent(domain)}`)
    .join('&');
  const response = await apiClient({
    method: 'GET',
    url: `v2/assets/threats/lookup?${query}`,
    ...(signal && { signal }),
  });
  return response.data;
};

export const useDomainLookupQuery = (domains: string[]) =>
  useQuery<DomainLookupResponse>({
    queryKey: ['domainLookup', domains],
    queryFn: ({ signal }) => lookupDomainsApi(domains, signal),
    enabled: domains.length > 0,
  });
